// ── Approval API ────────────────────────────────────────────────────
// Endpoint definitions live in @trackly/shared (createApprovalApi); this instantiates the
// single web-authenticated instance and re-exports its hooks so existing importers across
// Trackly.WebClient are unaffected by the shared-package extraction.
import { approvalApi } from './approvalApiBase';

export { approvalApi };
export const {
  useGetPendingApprovalsCountQuery,
  useGetPendingApprovalsQuery,
  useGetMyApprovalsQuery,
  useGetApprovalRequestQuery,
  useApproveStepMutation,
  useRejectStepMutation,
} = approvalApi;

// ── Types ──────────────────────────────────────────────────────────
export type {
  ApprovalRequest,
  ApprovalResponse,
  ApprovalScope,
  ApprovalStatusFilter,
  ListPendingApprovalsRequest,
  PendingApprovalsCount,
  ListMyApprovalsRequest,
  ApproveStepRequest,
  RejectStepRequest,
  ApprovalUiStatus,
} from '@trackly/shared';
export { deriveApprovalStatus } from '@trackly/shared';
